<template>
	<div>
		<h2>Import Workflow</h2>
		<p>Import an existing workflow</p>
		<el-divider></el-divider>
		<el-upload
			:multiple="false"
			:before-upload="before"
			:on-success="success"
			:on-error="error"
			ref="upload"
			:auto-upload="false"
			drag
			:action="endpoint"
			:headers="headers"
			:file-list="fileList"
			:on-exceed="exceed"
			:on-change="change"
			:on-remove="remove"
			accept=".zip"
			:limit="1"
		>
			<i style="font-size: 50px; margin-top: 30px; margin-bottom: 20px" class="el-icon-upload2"></i>
			<div class="el-upload__text">Drop workflow zip file here or <em>click to import</em></div>
			<div class="el-upload__tip" slot="tip">Workflow ZIP files only</div>
		</el-upload>
		<el-button
			@click="importWorkflow()"
			:disabled="disable"
			style="width: 100%; margin-top: 12px"
			type="primary"
			:loading="operationInProgress"
			>Import
		</el-button>
	</div>
</template>

<script>
import Vue from "vue";
export default {
	data() {
		return {
			fileList: [],
			headers: { Authorization: "Bearer " + Vue.$cookies.get("accessToken") },
			endpoint: process.env.VUE_APP_RUNTIME_ENDPOINT + "/workflow/importOne",
			operationInProgress: false,
			disable: true,
		};
	},
	methods: {
		importWorkflow() {
			this.$refs.upload.submit();
		},
		before() {
			this.operationInProgress = true;
		},
		success(result) {
			setTimeout(() => {
				this.disable = true;
				this.operationInProgress = false;
				this.$emit("operationComplete", result.workflow);
				this.$refs.upload.clearFiles();
				this.$notify({
					title: "Success",
					message: "Workflow imported",
					type: "success",
					position: "bottom-left",
				});
			}, 1000);
		},
		error(error) {
			this.disable = true;
			this.operationInProgress = false;
			this.$notifyError(this, error);
		},
		exceed() {},
		change(file) {
			if (file && file.status === "ready") {
				this.disable = false;
			} else {
				this.disable = true;
			}
		},
		remove() {
			this.disable = true;
		},
	},
};
</script>

<style>
.el-upload-dragger {
	width: 320px !important;
}
</style>
